// extracted by mini-css-extract-plugin
module.exports = {"menuMobile":"styles_menuMobile__YJUaO"};